exports.install = function (Vue, options) {
	Vue.prototype.api.Samplealarmlog = {
		getList(value={})//获取留样柜报警记录列表数据
		{
			value.sampleId=Vue.prototype.route.query.Did;
			return Vue.prototype.axiosget("/api/Samplealarmlog/getList",value)
			.then((response)=>{
				return response;
			});
		}
	};
}
